import React, { useState } from 'react'
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel,
  Button,
  Grid,
  CircularProgress,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import axios from 'axios'
import { usePostApplication } from '../../api/application'
import { useSnackbar } from 'notistack'
import moment from 'moment'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import UploadIcon from '@mui/icons-material/Upload'
import { useNavigate } from 'react-router-dom'

export const ApplicationForm = () => {
  const { register, handleSubmit, control, setValue } = useForm({
    mode: 'onChange',
  })
  const { mutateAsync, isLoading } = usePostApplication()
  const { enqueueSnackbar } = useSnackbar()

  const navigate = useNavigate()

  const [submitIsLoading, setSubmitIsLoading] = useState(false)
  const [uploadError, setUploadError] = useState('')

  // const { publicRuntimeConfig } = getConfig()

  // const host = publicRuntimeConfig.apiHost

  const date = moment().format('yyyy-MM-DD')

  const onSubmit = async (data) => {
    setSubmitIsLoading(true)
    const file = data?.invoice?.[0]

    const formData = new FormData()
    formData.append('htperformance', file, file?.name ?? '')

    const uploadRes = await axios({
      url: `/api/upload/htperformance-invoice`,
      method: 'POST',
      data: formData,
    })

    const res = await mutateAsync({
      ...data,
      invoiceImg: uploadRes?.data,
    }).catch((err) => {
      enqueueSnackbar(err?.response?.data?.message ?? 'Submit fail', {
        variant: 'error',
      })
    })
    if (res?.status === 200) {
      enqueueSnackbar('Application sent.', {
        variant: 'success',
      })
      navigate('/')
    }
    setSubmitIsLoading(false)
    return res
  }

  const tyrePatternArray = [
    {
      label: `N'Priz AH5`,
      value: `N'Priz AH5`,
    },
    {
      label: `N'Blue HD Plus`,
      value: `N'Blue HD Plus`,
    },
    {
      label: `N'Fera SU1`,
      value: `N'Fera SU1`,
    },
    {
      label: `N'Fera RU1`,
      value: `N'Fera RU1`,
    },
  ]

  return (
    <Box>
      <Box display='flex' justifyContent='center'>
        <img src={require('../../assets/Hoof-cover.png')} width='100%' />
      </Box>
      <Box sx={{ px: { xs: 3, sm: 10, md: 18 }, pb: 5 }}>
        <Box display='flex' justifyContent='flex-end' my={5}>
          <Button component='a' href='/' variant='outlined' size='small'>
            Back
          </Button>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={6}>
              <Controller
                name='name'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Name required',
                  maxLength: { value: 35, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Name'
                    fullWidth
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name='phone'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Phone number required',
                  pattern: {
                    value: /^[\+]?[0-9]{10,12}$/,
                    message: 'Invalid phone number',
                  },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Phone number'
                    variant='standard'
                    value={value}
                    fullWidth
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Controller
                name='email'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                  maxLength: { value: 50, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Email'
                    variant='standard'
                    value={value}
                    fullWidth
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name='carModel'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Car Model is required',
                  maxLength: { value: 25, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Car Model'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name='carRegistrationNumber'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Required',
                  maxLength: { value: 50, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Car Registration Number'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Controller
                name='warrantyCardNumber'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Required',
                  maxLength: { value: 50, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Warranty Card Number'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Controller
                name='tyrePattern'
                control={control}
                rules={{ required: 'Required' }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <FormControl fullWidth>
                    <InputLabel>Tyre Pattern</InputLabel>
                    <Select
                      onChange={onChange}
                      value={value ? value : ''}
                      variant='standard'
                      error={!!error}
                    >
                      {tyrePatternArray.map((each) => (
                        <MenuItem value={each.value} key={each.label}>
                          {each.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {error && <FormHelperText error={true}>{error?.message}</FormHelperText>}
                  </FormControl>
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name='tyreSize'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Required',
                  maxLength: { value: 50, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Tyre Size'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name='dotNumber'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Required',
                  maxLength: { value: 50, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='DOT Number'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Controller
                name='dealerCompanyName'
                control={control}
                defaultValue=''
                rules={{
                  required: 'Required',
                  maxLength: { value: 80, message: 'Exceed word count' },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    label='Dealer Company Name'
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    fullWidth
                    helperText={error ? error.message : null}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} display='flex' flexDirection='column' justifyContent='center'>
              <Box>
                <Controller
                  name='invoice'
                  control={control}
                  defaultValue=''
                  rules={{
                    required: 'Required',
                  }}
                  render={({ field: { value }, fieldState: { error } }) => {
                    const props = register('invoice')
                    const combinedOnchange = (e) => {
                      const fileSize = e?.target?.files?.[0]?.size
                      const fileMb = fileSize / 1024 ** 2
                      if (fileMb > 5) {
                        setUploadError('File size must be within 5MB.')
                        setValue('invoice', null)
                      } else {
                        props.onChange(e)
                        setUploadError('')
                      }
                    }
                    return (
                      <>
                        <Button variant='outlined' startIcon={<UploadIcon />} component='label'>
                          Upload Receipt/Invoice
                          <input
                            type='file'
                            accept='image/*'
                            hidden
                            {...props}
                            onChange={combinedOnchange}
                          />
                        </Button>
                        {error ? (
                          <FormHelperText error={true}>{error?.message}</FormHelperText>
                        ) : null}
                        {value ? <FormHelperText>{value[0]?.name}</FormHelperText> : null}
                        {/* throw error when file size is >2MB */}
                        {uploadError ? (
                          <FormHelperText error={true}>{uploadError}</FormHelperText>
                        ) : null}
                      </>
                    )
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} display='flex' flexDirection='column'>
              <Box>
                <Controller
                  name='invoiceDate'
                  control={control}
                  defaultValue={date}
                  rules={{
                    required: 'Required',
                  }}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label='Invoice Date'
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant='standard'
                            error={!!error}
                            fullWidth
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                />
              </Box>
            </Grid>
          </Grid>
          <Box mt={5} display='flex' justifyContent='flex-end'>
            {/* <Button
              variant='contained'
              color='primary'
              type='submit'
              style={{ padding: '12px 32px' }}
              disabled={isLoading || submitIsLoading}
            >
              {(isLoading || submitIsLoading) && (
                <CircularProgress style={{ color: '#fff' }} size='1.5rem' />
              )}
              Submit
            </Button> */}
          </Box>
        </form>
      </Box>
    </Box>
  )
}
